import React from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Formik } from 'formik';
import * as yup from 'yup';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { ModalAllder } from 'layouts/ModalAllder';
import { memberHandler } from '../../../redux/handlers';

const validationSchema = yup.object().shape({
  group_name: yup.string().required('ชื่อกลุ่มลูกค้าจำเป็นต้องระบุ')
});

export default function CustomerGroupFormModal({ modal, setModal, editData = null, onSuccess }) {
  const dispatch = useDispatch();
  const { businessSlug } = useParams();
  const isEditMode = Boolean(editData);

  const initialValues = {
    group_name: editData?.group_name || editData?.name || '',
    business_slug: businessSlug
  };

  const handleSubmit = async (values, { resetForm, setFieldError }) => {
    try {
      const requestBody = {
        name: values.group_name,
        business_slug: businessSlug
      };

      let response;

      if (isEditMode) {
        response = await dispatch(memberHandler.updateMemberGroup(editData.id, requestBody));
      } else {
        response = await dispatch(memberHandler.createMemberGroup(requestBody));
      }

      if (response) {
        if (!isEditMode) {
          resetForm();
        }
        setModal(prev => ({ ...prev, open: false }));
        if (typeof onSuccess === 'function') {
          onSuccess();
        }
      }
    } catch (error) {
      console.error('Error saving group:', error);
    }
  };

  const handleClose = () => {
    setModal(prev => ({ ...prev, open: false }));
  };

  return (
    <ModalAllder
      modal={modal}
      setModal={setModal}
      htitle={isEditMode ? 'แก้ไขกลุ่มลูกค้า' : 'เพิ่มกลุ่มลูกค้า'}
      hbtn={true}
    >
      <div className="py-4">
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ handleSubmit, handleChange, values, errors, touched, setFieldError }) => (
            <Form noValidate onSubmit={handleSubmit}>
              <Form.Group className="mb-3 form-st-3 pb-1">
                <Form.Label className="mb-1">
                  ชื่อกลุ่มลูกค้า <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="group_name"
                  placeholder="ชื่อกลุ่มลูกค้า"
                  value={values.group_name}
                  onChange={handleChange}
                  isInvalid={touched.group_name && !!errors.group_name}
                />
                <Form.Control.Feedback type="invalid">{errors.group_name}</Form.Control.Feedback>
              </Form.Group>

              <div className="pt-3 pb-3 btn-group-control text-center">
                <Button type="button" className="btn-st-6 me-3" style={{ width: '100px' }} onClick={handleClose}>
                  ยกเลิก
                </Button>
                <Button type="submit" className="btn-st-3" style={{ width: '100px' }}>
                  ยืนยัน
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </ModalAllder>
  );
}
